module.exports = __webpack_public_path__ + "supereasy-loading.svg?769d7c7efb36b7faa72ec5e49423f9a2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supereasy-loading.svg
// module id = 58
// module chunks = 0